
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/elevating-core-curriculum-with-curipod",
      function () {
        return require("private-next-pages/c/blog-posts/elevating-core-curriculum-with-curipod.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/elevating-core-curriculum-with-curipod"])
      });
    }
  